export const kinderConnectCaptureFormId = 'kinder-connect-capture-form-id';
